import React from 'react';
import { Reveal } from './Reveal';
import { GlassCall } from './ContactButtons';
const origins = [{
  place: 'Catemaco, México',
  detail: 'Formación en el Consejo de Catemaco'
}, {
  place: 'Rishikesh, India',
  detail: 'Centros de meditación y sanación'
}, {
  place: 'Varanasi & Haridwar',
  detail: 'Rituales de purificación ancestral'
}];
export function Proposal() {
  return <section className="relative w-full bg-ink py-16 sm:py-24" data-id="element-100" data-mp="10u0w95ieho32">
      <div className="absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-plum-deep/60 to-transparent" data-id="element-101" data-mp="10sg3nlfncf7u" />
      <div className="relative mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-[1.15fr_0.85fr] lg:gap-20" data-id="element-102" data-mp="vt3gezkv564q">
        <div data-id="element-103" data-mp="1alwvijw83k8v">
          <Reveal data-id="element-104" data-mp="15l0qg304xs1v">
            <p className="font-sans text-xs font-medium uppercase tracking-[0.35em] text-white/40" data-id="element-105" data-mp="15khcexdlvnt4">
              Nuestra propuesta
            </p>
          </Reveal>
          <Reveal delay={0.08} data-id="element-106" data-mp="1jifkxm58wq0p">
            <h2 className="mt-5 max-w-2xl font-serif text-4xl leading-[1.08] text-gold-light sm:text-5xl lg:text-6xl" data-id="element-107" data-mp="1em79oju65gyt">
              No estás solo(a), y sí existe una solución.
            </h2>
          </Reveal>
          <Reveal delay={0.16} data-id="element-108" data-mp="7u1vl2wlj79h">
            <p className="mt-8 max-w-2xl font-sans text-lg leading-relaxed text-white/70" data-id="element-109" data-mp="7t8vulw21i0u">
              Enfrentar el dolor del desamor o una relación que se aleja puede ser desgastante, pero
              también puede cambiar. Contamos con maestros con formación en el Consejo de Catemaco,
              México, y en centros espirituales de la India (Rishikesh, Varanasi y Haridwar).
              Trabajamos con conjuros personalizados según tu situación, siempre con ética y respeto,
              enfocados en atraer, recuperar, sanar o separar según lo que necesites.
            </p>
          </Reveal>
          <Reveal delay={0.24} data-id="element-110" data-mp="10jqvfcxkl19i">
            <div className="mt-10 flex justify-center sm:justify-start" data-id="element-111" data-mp="15h0rvcjdmd6u">
              <GlassCall data-id="element-112" data-mp="15exwse3d9tv9">Reserva tu consulta hoy mismo</GlassCall>
            </div>
          </Reveal>
        </div>

        <ul className="space-y-5 lg:pt-16" data-id="element-113" data-mp="36iqn11ky5va2">
          {origins.map((origin, i) => <Reveal as="li" key={origin.place} delay={0.1 + i * 0.1} data-id="element-114" data-mp="36gmc3zomrw0a" data-mpi={i}>
              <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 shadow-[0_30px_70px_-40px_rgba(0,0,0,0.9)] transition duration-200 ease-smooth" data-id="element-115" data-mp="31lqgkpk6qqif">
                <p className="font-serif text-2xl text-white" data-id="element-116" data-mp="3akbycihu21i5">{origin.place}</p>
                <p className="mt-2 font-sans text-sm text-white/55" data-id="element-117" data-mp="3p98428wf32fl">{origin.detail}</p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}